import { CreditCardIcon } from "@phosphor-icons/react/CreditCard";
import { Icon } from "../Icons/Icon";
import { Image } from "./Image";

type CardBrandSize = "sm" | "md" | "lg";

const sizeStyles: Record<CardBrandSize, { width: number; height: number }> = {
  sm: { width: 28, height: 16 },
  md: { width: 32, height: 20 },
  lg: { width: 52, height: 32 },
};

// The brand artwork is owned by ui-core (packages/ui-core/assets/credit-card-brands)
// and served to every consumer at /images/credit-card-brands via each app's
// vite-plugin-static-copy and ui-core Storybook's staticDirs — so the design
// system is the single source and no app commits its own copy. See
// packages/ui-core/assets/credit-card-brands/README.md.
const knownBrands = new Set([
  "visa",
  "mastercard",
  "amex",
  "001",
  "002",
  "003",
  "004",
  "006",
  "010",
  "016",
  "030",
  "cash",
  "cheque",
  "eft",
  "wire",
  "interac-etransfer",
  "generic-bank",
  "generic-credit-card",
]);

interface CardBrandIconProps {
  brand: string;
  size?: CardBrandSize;
}

export function CardBrandIcon({ brand, size = "md" }: CardBrandIconProps) {
  const dimensions = sizeStyles[size];

  if (knownBrands.has(brand)) {
    // `logo` is what earns these marks the dark-mode backdrop — several of the
    // bank glyphs are dark ink on transparent and vanish on a dark surface —
    // and hides a file we don't have rather than showing a broken image.
    return (
      <Image
        logo
        src={`/images/credit-card-brands/${brand}.png`}
        alt={brand}
        width={dimensions.width}
        height={dimensions.height}
      />
    );
  }

  return (
    <Icon
      icon={CreditCardIcon}
      size={size === "sm" ? "sm" : "md"}
      color="text-content-faint"
    />
  );
}
